import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { linkAnalyze } from './service.js';
import { replaceSrc, isWeChat } from '../utils';
import { getFinnalPath, dispatchPage } from '../utils/app';
// const handleClick = async e => {
//     if (e.target?.id === 'link') {
//         e.preventDefault();
//         e.stopPropagation();
//         const innerText = e.target?.getAttribute('link');
//         const realADom = e.target.nextSibling;
//
//         const link = innerText.startsWith('http') ? innerText : `http://${innerText}`;
//         const res = await linkAnalyze(link);
//         const inWeChat = isWeChat();
//
//         if (res.code === 0 && res.data.outLinkType === 1) {
//             if (inWeChat) {
//                 realADom.click();
//             } else {
//                 dispatchPage({ url: link, needOrigin: false });
//             }
//         } else if (inWeChat) {
//             realADom.href = `${window.location.origin + getFinnalPath()}/dangerPage?outLinkType=${
//                 res.data.outLinkType
//             }&shortLink=${res.data.shortLink}`;
//             realADom.click();
//         } else {
//             dispatchPage({
//                 url: `/dangerPage?outLinkType=${res.data.outLinkType}&shortLink=${res.data.shortLink}`,
//             });
//         }
//
//         return false;
//     }
// };

const formatReg = tag => {
    let str = '';
    const len = tag.length;

    for (let i = 0; i < len; i++) {
        const reg = /^[\u4E00-\u9FA5A-Za-z0-9\s]+$/;

        if (reg.test(tag[i])) {
            str += tag[i];
        } else {
            str += `\\${tag[i]}`;
        }
    }

    return str;
};

const Text = ({ text, tag, link, forwardUser }) => {
    // const text = ' #ceshi #地铁# txt';
    // 特殊字符的标签名称先转一下格式，避免正则匹配BUG
    const [repText, setRepText] = useState('');

    const formatTag = tag || []?.filter(item => item).map(item => formatReg(item));

    const getNewText = () => {
        let str = text;

        for (let i = 0; i < formatTag?.length; i++) {
            str = str?.replace(new RegExp(formatTag[i], 'g'), word => {
                return `<span style="color: #3091f5;" id="tag">${word}</span>`;
            });
        }

        if (forwardUser) {
            str = str?.replace(`@${forwardUser?.nickName}：`, word => {
                return `<span style="color: #3091f5;">${word}</span>`;
            });
        }

        return text;
    };
    const newText = async () => {
        const newTexts = getNewText();

        const result = await replaceSrc(newTexts, link);

        setRepText(result);
    };

    useEffect(
        () => {
            if (text) {
                newText();
            }
        },
        [text],
    );

    return <span dangerouslySetInnerHTML={{ __html: repText }} />;
};

Text.propTypes = {
    /**
     * 文本
     */
    text: PropTypes.string,
    /**
     * 标签
     */
    tag: PropTypes.array,
    /**
     * 转发的原帖子用户信息
     */
    forwardUser: PropTypes.object,
    link: PropTypes.array,
};

export default Text;
